import { PricesPage } from '@components/buzzkuri/pages/Prices'
import { useStaticPagesRes } from '@hook/useStaticPagesRes'
import { StaticPagesRes } from '@type/buzzkuri/static-page'
import { ErrorStatus } from '@type/common'
import { getDomain, getPagePropsReq } from '@utils/http'
import { GetServerSidePropsContext } from 'next'
import { ParsedUrlQuery } from 'querystring'
import { BusinessHead } from '@components/layouts/BusinessHead'
import { cloudfrontPath } from '@utils/image'

const Prices = (props: StaticPagesRes | ErrorStatus): JSX.Element => {
  const staticPagesRes = useStaticPagesRes(props)

  return (
    <>
      <BusinessHead
        noindex={false}
        title="料金プラン"
        description="バヅクリの料金プラン「通常プラン」「バヅクリ エモ」をご紹介します。社内イベントの開催頻度や参加人数・規模に応じてお選びいただけます。"
        openGraph={{
          url: `https://${getDomain}/prices`,
          images: [
            {
              url: `${cloudfrontPath}/images/prices/prices-normal-01b.png`,
              width: 1000,
              height: 680,
            },
          ],
        }}
      />
      <PricesPage {...staticPagesRes} />
    </>
  )
}

export default Prices

export async function getServerSideProps(
  context: GetServerSidePropsContext<ParsedUrlQuery>
): Promise<{ props: StaticPagesRes | ErrorStatus }> {
  return getPagePropsReq(
    context,
    '/api/static_pages',
    '',
    false,
    'POST'
  ) as Promise<{
    props: StaticPagesRes | ErrorStatus
  }>
}
